// extracted by mini-css-extract-plugin
export var content = "_ay-3";
export var list = "_ay-4";
export var settingsContent = "_ay-7";
export var settingsPanel = "_ay-8";
export var state = "_ay-6";
export var triggerBadge = "_ay-2";
export var triggerButton = "_ay-1";
export var triggerShell = "_ay-0";
export var unreadDot = "_ay-5";